// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-table {
  --chartkit-bg-bar-offset-width: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.chartkit-table_size_l {
  --data-table-row-height: 30px;
  --dl-table-font-size: 13px;
  --data-table-header-vertical-padding: 4px;
  --data-table-cell-vertical-padding: 5px;
  --data-table-cell-horizontal-padding: 10px;
  --dl-table-cell-bar-height: 19px;
  --chartkit-bg-bar-offset-width: 10px;
  line-height: 16px;
}
.chartkit-table_size_m {
  --data-table-row-height: 24px;
  --dl-table-font-size: 12px;
  --data-table-header-vertical-padding: 3px;
  --data-table-cell-vertical-padding: 4px;
  --data-table-cell-horizontal-padding: 6px;
  --chartkit-bg-bar-offset-width: 6px;
  --dl-table-cell-bar-height: 17px;
  line-height: 15px;
}
.chartkit-table_size_s {
  --data-table-row-height: 20px;
  --dl-table-font-size: 11px;
  --data-table-header-vertical-padding: 2px;
  --data-table-cell-vertical-padding: 3px;
  --data-table-cell-horizontal-padding: 4px;
  --chartkit-bg-bar-offset-width: 4px;
  --dl-table-cell-bar-height: 15px;
  line-height: 13px;
}
.chartkit-table__body {
  overflow: auto;
  flex-grow: 0;
  flex-shrink: 1;
}
.chartkit-table__title {
  font-weight: bold;
  padding: 5px 40px 5px 0;
  text-align: right;
}
.chartkit-table__head-cell {
  white-space: pre-line;
}
.chartkit-table__head-cell_with-markup {
  font-weight: normal;
}
.chartkit-table__cell {
  height: 100%;
  font-size: var(--dl-table-font-size);
  box-sizing: border-box;
}
.chartkit-table__cell_type_bar {
  height: inherit;
  vertical-align: middle;
}
.chartkit-table__cell_with-fixed-width {
  white-space: normal;
  word-break: break-word;
}
.chartkit-table__cell_sortable:hover {
  cursor: pointer;
}
.chartkit-table__cell_selectable.data-table__td:hover {
  background: var(--data-table-color-hover-area);
  cursor: pointer;
  opacity: 1 !important;
}
.chartkit-table__cell_type_grid:not(th) {
  padding: 0;
}
.chartkit-table__link {
  display: block;
  height: 100%;
}
.chartkit-table__content {
  background-clip: padding-box;
  min-width: 100%;
  height: 100%;
}
.chartkit-table__content_number {
  text-align: right;
}
.chartkit-table__content_null {
  font-style: italic;
  opacity: 0.5;
}
.chartkit-table__content_with-fixed-height {
  height: unset;
}
.chartkit-table__diff {
  font-size: 0.8em;
}
.chartkit-table__diff_pos {
  color: #008000;
}
.chartkit-table__diff_neg {
  color: #ff0000;
}
.chartkit-table__grid-wrapper {
  display: grid;
  grid-auto-rows: auto;
  grid-auto-columns: auto;
}
.chartkit-table__grid-wrapper_flow_column {
  grid-auto-flow: column;
}
.chartkit-table__grid-wrapper_flow_row {
  grid-auto-flow: row;
}
.chartkit-table__grid-wrapper .chartkit-table__content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
}
.chartkit-table__grid-wrapper:not(.chartkit-table__grid-wrapper_flow_row):not(.chartkit-table__grid-wrapper_flow_column) > .chartkit-table__content:not(:last-child) {
  border-bottom: 1px solid var(--data-table-border-color);
}
.chartkit-table__grid-wrapper_flow_column > .chartkit-table__grid-wrapper_flow_row:not(:last-child) .chartkit-table__content {
  border-right: 1px solid var(--data-table-border-color);
}
.chartkit-table__grid-wrapper_flow_row > .chartkit-table__grid-wrapper_flow_column:not(:last-child) .chartkit-table__content {
  border-bottom: 1px solid var(--data-table-border-color);
}
.chartkit-table__cell .table-action-btn:has(.g-button__icon:only-child) {
  height: 16px;
  width: 16px;
  line-height: 16px;
}
.chartkit-table__cell .table-action-btn:has(.g-button__icon:only-child) .g-button__icon {
  height: 16px;
  width: 12px;
}
.chartkit-table__sort-icon {
  margin-left: 10px;
  transform: rotate(-90deg);
}
.chartkit-table__sort-icon_desc {
  transform: rotate(90deg);
}
.chartkit-table__column-hint {
  margin-left: 4px;
}

.chartkit-table .data-table__table {
  min-width: calc(100% - 1px);
}
.chartkit-table .data-table__sort-icon {
  margin-right: 2%;
}
.chartkit-table .data-table__sort-icon_shadow {
  display: none;
}
.chartkit-table .data-table thead tr {
  height: var(--data-table-row-height);
}
.chartkit-table .data-table__box_sticky-head_moving thead tr {
  height: 0px;
}
.chartkit-table .data-table__td {
  height: auto;
}
.chartkit-table .data-table__th {
  font-size: var(--dl-table-font-size);
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/components/Widget/components/Table/Table.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAAJ;AAGQ;EACI,6BAAA;EACA,0BAAA;EACA,yCAAA;EACA,uCAAA;EACA,0CAAA;EACA,gCAAA;EACA,oCAAA;EACA,iBAAA;AADZ;AAIQ;EACI,6BAAA;EACA,0BAAA;EACA,yCAAA;EACA,uCAAA;EACA,yCAAA;EACA,mCAAA;EACA,gCAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,6BAAA;EACA,0BAAA;EACA,yCAAA;EACA,uCAAA;EACA,yCAAA;EACA,mCAAA;EACA,gCAAA;EACA,iBAAA;AAHZ;AAOI;EACI,cAAA;EACA,YAAA;EACA,cAAA;AALR;AAQI;EACI,iBAAA;EACA,uBAAA;EACA,iBAAA;AANR;AASI;EACI,qBAAA;AAPR;AASQ;EACI,mBAAA;AAPZ;AAWI;EACI,YAAA;EACA,oCAAA;EACA,sBAAA;AATR;AAWQ;EAEI,eAAA;EACA,sBAAA;AAVZ;AAaQ;EACI,mBAAA;EACA,sBAAA;AAXZ;AAcQ;EACI,eAAA;AAZZ;AAeQ;EACI,8CAAA;EACA,eAAA;EAGA,qBAAA;AAfZ;AAmBI;EACI,UAAA;AAjBR;AAoBI;EAEI,cAAA;EACA,YAAA;AAnBR;AAsBI;EAEI,4BAAA;EACA,eAAA;EACA,YAAA;AArBR;AAuBQ;EACI,iBAAA;AArBZ;AAwBQ;EACI,kBAAA;EACA,YAAA;AAtBZ;AAyBQ;EACI,aAAA;AAvBZ;AA2BI;EACI,gBAAA;AAzBR;AA2BQ;EACI,cAAA;AAzBZ;AA4BQ;EACI,cAAA;AA1BZ;AA8BI;EACI,aAAA;EACA,oBAAA;EACA,uBAAA;AA5BR;AA8BQ;EACI,sBAAA;AA5BZ;AA+BQ;EACI,mBAAA;AA7BZ;AAiCI;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AA/BR;AAkCI;EAEI,uDAAA;AAjCR;AAoCI;EACI,sDAAA;AAlCR;AAqCI;EACI,uDAAA;AAnCR;AAsCI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AApCR;AAsCQ;EACI,YAAA;EACA,WAAA;AApCZ;AAwCI;EACI,iBAAA;EACA,yBAAA;AAtCR;AAwCQ;EACI,wBAAA;AAtCZ;AA0CI;EACI,gBAAA;AAxCR;;AA6CI;EAGI,2BAAA;AA5CR;AA+CI;EACI,gBAAA;AA7CR;AA+CQ;EACI,aAAA;AA7CZ;AAiDI;EACI,oCAAA;AA/CR;AAkDI;EACI,WAAA;AAhDR;AAmDI;EAEI,YAAA;AAlDR;AAqDI;EACI,oCAAA;AAnDR","sourcesContent":[".chartkit-table {\n  --chartkit-bg-bar-offset-width: 10px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: auto;\n}\n.chartkit-table_size_l {\n  --data-table-row-height: 30px;\n  --dl-table-font-size: 13px;\n  --data-table-header-vertical-padding: 4px;\n  --data-table-cell-vertical-padding: 5px;\n  --data-table-cell-horizontal-padding: 10px;\n  --dl-table-cell-bar-height: 19px;\n  --chartkit-bg-bar-offset-width: 10px;\n  line-height: 16px;\n}\n.chartkit-table_size_m {\n  --data-table-row-height: 24px;\n  --dl-table-font-size: 12px;\n  --data-table-header-vertical-padding: 3px;\n  --data-table-cell-vertical-padding: 4px;\n  --data-table-cell-horizontal-padding: 6px;\n  --chartkit-bg-bar-offset-width: 6px;\n  --dl-table-cell-bar-height: 17px;\n  line-height: 15px;\n}\n.chartkit-table_size_s {\n  --data-table-row-height: 20px;\n  --dl-table-font-size: 11px;\n  --data-table-header-vertical-padding: 2px;\n  --data-table-cell-vertical-padding: 3px;\n  --data-table-cell-horizontal-padding: 4px;\n  --chartkit-bg-bar-offset-width: 4px;\n  --dl-table-cell-bar-height: 15px;\n  line-height: 13px;\n}\n.chartkit-table__body {\n  overflow: auto;\n  flex-grow: 0;\n  flex-shrink: 1;\n}\n.chartkit-table__title {\n  font-weight: bold;\n  padding: 5px 40px 5px 0;\n  text-align: right;\n}\n.chartkit-table__head-cell {\n  white-space: pre-line;\n}\n.chartkit-table__head-cell_with-markup {\n  font-weight: normal;\n}\n.chartkit-table__cell {\n  height: 100%;\n  font-size: var(--dl-table-font-size);\n  box-sizing: border-box;\n}\n.chartkit-table__cell_type_bar {\n  height: inherit;\n  vertical-align: middle;\n}\n.chartkit-table__cell_with-fixed-width {\n  white-space: normal;\n  word-break: break-word;\n}\n.chartkit-table__cell_sortable:hover {\n  cursor: pointer;\n}\n.chartkit-table__cell_selectable.data-table__td:hover {\n  background: var(--data-table-color-hover-area);\n  cursor: pointer;\n  opacity: 1 !important;\n}\n.chartkit-table__cell_type_grid:not(th) {\n  padding: 0;\n}\n.chartkit-table__link {\n  display: block;\n  height: 100%;\n}\n.chartkit-table__content {\n  background-clip: padding-box;\n  min-width: 100%;\n  height: 100%;\n}\n.chartkit-table__content_number {\n  text-align: right;\n}\n.chartkit-table__content_null {\n  font-style: italic;\n  opacity: 0.5;\n}\n.chartkit-table__content_with-fixed-height {\n  height: unset;\n}\n.chartkit-table__diff {\n  font-size: 0.8em;\n}\n.chartkit-table__diff_pos {\n  color: #008000;\n}\n.chartkit-table__diff_neg {\n  color: #ff0000;\n}\n.chartkit-table__grid-wrapper {\n  display: grid;\n  grid-auto-rows: auto;\n  grid-auto-columns: auto;\n}\n.chartkit-table__grid-wrapper_flow_column {\n  grid-auto-flow: column;\n}\n.chartkit-table__grid-wrapper_flow_row {\n  grid-auto-flow: row;\n}\n.chartkit-table__grid-wrapper .chartkit-table__content {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 5px;\n  box-sizing: border-box;\n}\n.chartkit-table__grid-wrapper:not(.chartkit-table__grid-wrapper_flow_row):not(.chartkit-table__grid-wrapper_flow_column) > .chartkit-table__content:not(:last-child) {\n  border-bottom: 1px solid var(--data-table-border-color);\n}\n.chartkit-table__grid-wrapper_flow_column > .chartkit-table__grid-wrapper_flow_row:not(:last-child) .chartkit-table__content {\n  border-right: 1px solid var(--data-table-border-color);\n}\n.chartkit-table__grid-wrapper_flow_row > .chartkit-table__grid-wrapper_flow_column:not(:last-child) .chartkit-table__content {\n  border-bottom: 1px solid var(--data-table-border-color);\n}\n.chartkit-table__cell .table-action-btn:has(.g-button__icon:only-child) {\n  height: 16px;\n  width: 16px;\n  line-height: 16px;\n}\n.chartkit-table__cell .table-action-btn:has(.g-button__icon:only-child) .g-button__icon {\n  height: 16px;\n  width: 12px;\n}\n.chartkit-table__sort-icon {\n  margin-left: 10px;\n  transform: rotate(-90deg);\n}\n.chartkit-table__sort-icon_desc {\n  transform: rotate(90deg);\n}\n.chartkit-table__column-hint {\n  margin-left: 4px;\n}\n\n.chartkit-table .data-table__table {\n  min-width: calc(100% - 1px);\n}\n.chartkit-table .data-table__sort-icon {\n  margin-right: 2%;\n}\n.chartkit-table .data-table__sort-icon_shadow {\n  display: none;\n}\n.chartkit-table .data-table thead tr {\n  height: var(--data-table-row-height);\n}\n.chartkit-table .data-table__box_sticky-head_moving thead tr {\n  height: 0px;\n}\n.chartkit-table .data-table__td {\n  height: auto;\n}\n.chartkit-table .data-table__th {\n  font-size: var(--dl-table-font-size);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
